import {IFreePlayGameViewModel} from "./free-play-game-view-model.interface";
import {GameInfo} from "../../games/game-info";
import {IFreePlayVoucherModel} from "../vouchers/free-play-voucher.model.interface";
import {Check} from "@sparkware/app-utils";

export class FreePlayGameModel implements IFreePlayGameViewModel {
    constructor(private readonly voucher: IFreePlayVoucherModel,
                public readonly gameInfo: GameInfo) {
    }

    get hasEnoughBalanceToBet(): boolean {
        return this.voucher.currentBalance > 0
            && (Check.isNullOrUndefined(this.gameInfo.minBet) || this.gameInfo.minBet <= this.voucher.currentBalance)
    }
    async play(): Promise<void> {

        await this.gameInfo.open({
            isRealMode: true,
            freePlayParams: {
                freePlayId: this.voucher.id,
                freePlayType: this.voucher.freePlayType
            }
        });

    }

}